import React, { useState } from 'react';
import { Box, Typography, Button, TextField, Paper } from '@mui/material';
import api from './AxiosConfig';
import Loading from "../Loading";

const AdminAddRestaurant = ({ token, onBack }) => {
    const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        city: '',
        postcode: '',
        street: '',
        houseNumber: '',
        phone: '',
        email: '',
        firstName: '',
        lastName: '',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await api.post(`${baseUrl}/api/admin/addRestaurant`, formData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            alert(response.data);
            onBack();
        } catch (error) {
            alert('Błąd przy dodawaniu restauracji');
        } finally {
            setLoading(false)
        }
    };

    return (
        <Box>
            <Loading open={loading} />
            <Button onClick={onBack} variant="outlined" sx={{ mb: 2 }}>
                Powrót
            </Button>
            <Paper sx={{ p: 2 }}>
                <Typography variant="h5" sx={{ mb: 2 }}>
                    Dodaj Restaurację
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Nazwa"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Miasto"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Kod pocztowy"
                        name="postcode"
                        value={formData.postcode}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Ulica"
                        name="street"
                        value={formData.street}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Numer domu"
                        name="houseNumber"
                        value={formData.houseNumber}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Telefon"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Imię"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Nazwisko"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <Button type="submit" variant="contained">
                        Dodaj
                    </Button>
                </form>
            </Paper>
        </Box>
    );
};

export default AdminAddRestaurant;